module.exports = __webpack_public_path__ + "img/IT0001782075931.fd5feb73.png";